import { MutableRefObject } from "react"

import { scrollIntoViewWithOptions } from "modules/Booking/FormPage/common/utils/helpers"

export function focusOnField(
    input: MutableRefObject<HTMLInputElement | null>,
    label: MutableRefObject<HTMLElement | null>
) {
    if (!(input?.current || label?.current)) return false
    input?.current && input.current.focus()
    label?.current && scrollIntoViewWithOptions(label.current)
    return true
}
